import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

const Cypher = ({ team, target }: TPage) => {
  return (
    <Lock
      target={target}
      lockType="letter"
      combination="WORD"
      text={
        <Typography tag="h4">
          Cats are, like this message, always one step ahead!
          <br />
          <br />
          Decode the message and find the password that will guide you to the
          next task!
        </Typography>
      }
    />

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default Cypher;
